import styled from 'styled-components';

export const StyledProcedureInformationRecap = styled.main`
  background-color: #fff;
  display: flex;
  flex-direction: column;
  .procedure-information-title {
    font-size: 18px;
    font-weight: bold;
    color: #2b2727;
    margin-top: -10px;
    margin-bottom: 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .procedure {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 24px;
  }
  .field {
    flex: 1 0 24%;
    border-bottom: 1px solid #dddddd;
    margin-right: 24px;
  }
  .label {
    color: #8b8b8b;
    font-size: 11px;
  }
  .value {
    padding: 8px 0;
    border-radius: 2px;
    font-weight: bold;
    font-size: 13px;
    color: #2b2727;
  }
  .checkbox {
    margin-top: 24px;
    display: flex;
    align-items: center;
  }
  .checkbox-label {
    margin-right: 20px;
  }
`;

export const StyledCivilPartyRecap = styled.div`
  margin: 15px 0;
  .civil-party-content {
    width: 100%;
    border-radius: 4px;
    box-shadow: 0px 1px 3px #0000001f;
    padding: 16px;
    display: block;
  }

  .uploaded-civil-doc {
    margin-bottom: 9px;
  }
  .civil_party_select_vicitms {
    margin-bottom: 16px;
  }
  .civil-document-recap-sub-title {
    font-size: 13px;
    color: #8b8b8b;
    margin-bottom: 9px;
  }
  .consult {
    cursor: pointer;
  }

  .check_box_container {
    display: flex;
    justify-content: flex-start;
  }

  .check_box_div {
    min-width: 100px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 1px 3px #0000001f;
    border-radius: 4px;
    margin-right: 16px;
    padding: 0 12px;
    text-align: center;
    font-size: 15px;
    color: #ffffff;
  }

  .victim-name {
    font-size: 13px;
    font-family: Roboto;
    font-weight: Medium;
    letter-spacing: 0px;
    color: #2b2727;
  }
`;

export const StyledJudgementAddPronouncingRecap = styled.div`
  margin: 15px 0;
  .content-wrapper {
    width: 100%;
    border-radius: 4px;
    box-shadow: 0px 1px 3px #0000001f;
    padding: 16px;
    display: block;
  }
  .add-info {
    display: flex;
    justify-content: space-between;
  }
  .field {
    width: 40%;
    border-bottom: 1px solid #dddddd;
    margin-right: 24px;
  }
  .label {
    color: #8b8b8b;
    font-size: 11px;
  }
  .value {
    padding: 8px 0;
    border-radius: 2px;
    font-weight: bold;
    font-size: 13px;
    color: #2b2727;
  }
  .document-recap {
    padding-top: 24px;
  }
  .document-recap-title {
    margin-bottom: 9px;
    font-size: 13px;
    color: #8b8b8b;
  }
  .consult {
    cursor: pointer;
  }
  .expertises {
  }
  .expertise-bloc-title {
    font-size: 18px;
    font-weight: bold;
    color: #2b2727;
    margin-top: 16px;
  }
  .expertise {
    margin-top: 16px;
    padding: 16px;
    background-color: #f4f4f4;
    border-radius: 4px;
  }
  .expertise-title {
    font-weight: bold;
    font-size: 14px;
    color: #0072c6;
    text-transform: uppercase;
    margin-bottom: 16px;
  }
  .list-container {
    padding-top: 16px;
  }
  .items-container {
    display: flex;
  }
  .items {
    display: flex;
    align-items: center;
  }
  .item {
    background-color: #fff;
    box-shadow: 0px 1px 3px #0000001f;
    border-radius: 4px;
    height: 36px;
    color: #2b2727;
    font-size: 13px;
    font-weight: bold;
    display: flex;
    align-items: center;
    padding: 10px 16px;
    margin-right: 12px;
    min-width: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .list-title {
    font-size: 13px;
    color: #8b8b8b;
    margin-bottom: 8px;
  }
  .expertise-items {
    display: flex;
    flex-direction: column;
  }
  .item-container {
    display: flex;
    align-items: flex-end;
    width: 100%;
  }
  .field-expert {
    width: 22%;
    border-bottom: 1px solid #dddddd;
    margin-left: 24px;
  }
  .section {
    justify-content: flex-start;
    flex-direction: row;
    display: flex;
    align-items: center;
    line-height: 0px;
    margin-left: 5px;
  }
`;
export const Container = styled.main`
  .decision-sub-bloc-title {
    font-weight: bold;
  }
  .decision-status {
    padding: 8px 0;
    font-size: 14px;
    color: #2b2727;
  }
  .decision-status > * {
    margin-right: 16px;
  }

  .jadd-decision-recap-container {
    display: flex;
    flex-direction: column;
    margin-top: 15px;
    align-items: left;
    margin: 0;
    align-self: center;
  }
  .decision-recap-container-title {
    font-weight: bold;
    font-size: 14px;
    color: #0072c6;
    text-transform: uppercase;
    padding-top: 10px;
    margin: 0;
  }
  .decision-recap-container-status {
    padding-top: 10px;
    font-size: 14px;
    margin: 0;
  }
  .jadd-decision-recap {
    display: flex;
    flex-direction: row;
    align-items: baseline;
  }
`;
export const Forms = styled.div`
  position: relative;
  .add-document {
    position: absolute;
    right: 0;
  }
  .icon {
    height: 14px;
    width: 14px;
    margin-right: 8px;
  }
  .add-judgement-add-pronoucing-style {
    padding: 10px 16px;
  }
`;
